const TITLES = ['override justification', 'reason']

export const isOverrideJustificationTitle = (title?: string): boolean => {
  if (!title) {
    return false
  }

  return TITLES.includes(title.trim().toLowerCase())
}
